module.exports = __webpack_public_path__ + "static/img/file-play-time.405947dd.png";